import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-lob-resources';

@Injectable({
  providedIn: 'root'
})
export class LobService {

  constructor(private fabricService: FabricService) {}

  getLineOfBusiness(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_line-of-business_mgmt_line-of-business');
  }

  postLineOfBusiness(lobForm): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_line-of-business_mgmt_line-of-business', lobForm);
  }

  deletedLineOfBusiness(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'deleted_line-of-business_id', {id});
  }

  putLineOfBusiness(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_line-of-business_id', {id});
  }

}
